var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMatchTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3333 12.9997H25.6667C25.6667 6.00467 19.995 0.333008 13 0.333008V5.66634C17.05 5.66634 20.3333 8.94967 20.3333 12.9997Z",
    fill: "#FD93AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9987 20.333C8.9487 20.333 5.66536 17.0497 5.66536 12.9997C5.66536 8.94967 8.9487 5.66634 12.9987 5.66634V0.333008C6.0037 0.333008 0.332031 6.00467 0.332031 12.9997C0.332031 19.9947 6.0037 25.6663 12.9987 25.6663C16.497 25.6663 19.6637 24.248 21.9554 21.9563L18.1837 18.1847C16.857 19.5113 15.0237 20.333 12.9987 20.333Z",
    fill: "#FFF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3319 13C20.3319 15.025 19.5119 16.8583 18.1836 18.185L21.9553 21.9567C24.2469 19.665 25.6653 16.4983 25.6653 13H20.3319Z",
    fill: "#FEC8D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.0013 12.4997C14.29 12.4997 15.3346 11.455 15.3346 10.1663C15.3346 8.87768 14.29 7.83301 13.0013 7.83301C11.7126 7.83301 10.668 8.87768 10.668 10.1663C10.668 11.455 11.7126 12.4997 13.0013 12.4997Z",
    fill: "#FD93AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8782 17.4993C14.2482 17.4993 11.7532 17.4993 10.1232 17.4993C9.15154 17.4993 8.49987 16.491 8.90987 15.6093C9.62154 14.0827 11.1849 13.0977 12.9999 13.0977C14.8149 13.0977 16.3799 14.0843 17.0899 15.6093C17.4999 16.4893 16.8482 17.4993 15.8765 17.4993H15.8782Z",
    fill: "#FD93AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatchTest);
export default __webpack_public_path__ + "static/media/icon_match_test.abf92ebc.svg";
export { ForwardRef as ReactComponent };